import React, {useState} from "react";
import { useSelector } from "react-redux";

import { Button, Table } from "react-bootstrap";
import { Pagination } from "../pagination/pagination.js";

import { Link } from "react-router-dom";

import { FaListAlt } from "react-icons/fa";
import { CSVLink } from "react-csv";
const QRCode = require("qrcode.react");

export const TicketTable = (props) => {
  const { searchTicketList, isLoading, error } = useSelector(
    (state) => state.tickets
  );

      const [data, setData] = useState([]);


    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);


  if (error) return <h3>{error}</h3>;

    const ticketData = searchTicketList;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = searchTicketList.slice(
     indexOfFirstRecord,
     indexOfLastRecord
   );
   const nPages = Math.ceil(searchTicketList.length / recordsPerPage);


  return (
    <>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#Ticket ID</th>
            <th>Customer Name</th>
            <th>Status</th>
            <th>Opened Date</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.length ? (
            currentRecords.map((row, index) => (
              <tr key={row._id}>
                <td style={{ display: "flex" }}>
                  <Link to={`/ticket/${row._id}`}>{row._id}</Link>
                </td>

                <td>
                  <div>{row.customerName}</div>
                </td>
                {row.status === "Closed" ? (
                  <td style={{ backgroundColor: "#93CA5B" }}>{row.status}</td>
                ) : (
                  <td style={{ backgroundColor: "#FF9DA2" }}>{row.status}</td>
                )}
                <td>{row.openAt && new Date(row.openAt).toLocaleString()}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No ticket to show{" "}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Pagination
        nPages={nPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
};
